import { createAsyncThunk } from "@reduxjs/toolkit";
import API from "../../API";

export const getInstalledExtensions = createAsyncThunk(
  "extensions/getInstalledExtensions",
  async (_, { rejectWithValue }) => {
    try {
      const response = await API({
        url: `admin/extension/GetExtensions`,
        method: "get",
      });
      if (response.status === 200) {
        return response?.data?.data?.records;
      } else {
        return rejectWithValue("Unexpected API response");
      }
    } catch (error) {
      console.error("API ERROR:", error);
      return rejectWithValue(error);
    }
  },
);
